import React, { lazy, memo, Suspense, useCallback, useEffect, useRef, useState } from 'react'
import { getCommonAssetPath, getGeoAssetPath } from '../../geo/config'
import { useGeoRuntime } from '../../geo/useGeoRuntime'
import { classNames } from '@monorepo/utils'
import styles from './styles.module.css'
const LoginForm = lazy(() => import('../LoginForm'))

interface ModalProps {
  isOpenModal: number
  closeModal: () => void
}

const Modal: React.FC<ModalProps> = ({ isOpenModal, closeModal }) => {
  const openTimeRef = useRef<number | null>(null)
  const isProcessingRef = useRef<boolean>(false)
  const [isActivePrize, setIsActivePrize] = useState<number | null>(null)
  const [isOpenForm, setIsOpenForm] = useState(false)
  const { geo, geoConfig } = useGeoRuntime()

  useEffect(() => {
    if (isOpenModal) {
      openTimeRef.current = Date.now()
      isProcessingRef.current = false
    }
    if (isOpenModal === 2) requestAnimationFrame(() => setIsActivePrize(1))
    if (isOpenModal === 1) requestAnimationFrame(() => setIsActivePrize(2))
  }, [isOpenModal])

  useEffect(() => {
    if (!isOpenForm && isOpenModal === 1) {
      setTimeout(() => {
        setIsOpenForm(true)
      }, 2000)
    }
  }, [isOpenModal])

  const handleClick = useCallback(() => {
    if (isProcessingRef.current) return
    isProcessingRef.current = true
    if (isOpenModal === 2) {
      closeModal()
      setIsActivePrize(null)
    }
  }, [closeModal, isOpenModal])

  if (!isOpenModal) return null

  const chips1 = getCommonAssetPath('chips1.webp')
  const chips2 = getCommonAssetPath('chips2.webp')
  const prize = getGeoAssetPath(geo, geoConfig.layout.prize.element.desktop)
  const decor = getCommonAssetPath('decorDesktop.webp')

  

  return (
    <>
      {isOpenModal === 1 && <div className={styles.backgroundImageFilter} />}
      <div
        className={classNames(styles.modalMask, isOpenForm && styles.regMask)}
        onClick={handleClick}
      >
        <div className={styles.prize300Container}>
          <div
            className={classNames(styles.prize300, isActivePrize === 1 && styles.activePrize)}
          ></div>
        </div>
        {!isOpenForm && (
          <div className={styles.prizeContainer}>
            <img
              className={classNames(styles.prize, isActivePrize === 2 && styles.activePrize)}
              src={prize}
              alt="Prize"
            />
          </div>
        )}

        {isOpenForm && (
          <div className={styles.modalContainer}>
            <img className={styles.chips1} src={chips1} alt="chips" />
            <img className={styles.chips2} src={chips2} alt="chips" />
            <img className={styles.decor} src={decor} alt="chips" />
            <div className={styles.registerFormContainer}>
              <Suspense fallback={null}>
                <LoginForm />
              </Suspense>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default memo(Modal)
